import {
  hostInvoices,
  attachHostInvoice,
  createHostInvoice,
  pendingHostInvoices,
  updateFileHostInvoice,
} from './hostInvoiceService'
import { uploadToS3 } from '@/services/upload/uploadService'
import { errorMessages } from '@/util/helpers'
import Vue from 'vue'

const state = {
  hostUserInvoices: [],
  hostUserPendingInvoices: [],
  isHostUserInvoiceLoading: false,
}

const getters = {
  hostUserInvoices: (state) => state.hostUserInvoices,
  hostUserPendingInvoices: (state) => state.hostUserPendingInvoices,
  isHostUserInvoiceLoading: (state) => state.isHostUserInvoiceLoading,
}

const actions = {
  async fetchHostUserInvoices({ commit, dispatch, rootState }) {
    commit('setIsLoading', true)

    const defaultParams = {
      size: rootState.paginate.itemsPerPage,
      page: rootState.paginate.currentPage - 1,
    }

    const params = { ...defaultParams, ...rootState.filters.filters, ...{ sender: 'HOST' } }

    try {
      const { data } = await hostInvoices(params)
      const { result, total } = await data

      commit('setHostUserInvoices', result)
      commit('setTotalPages', total)
    } catch ({ data }) {
        data?.errors && data?.errors?.length >= 1
          ? dispatch('showErrorMessage', errorMessages(data.errors))
          : dispatch('showErrorMessage', data.message)
    } finally {
      commit('setIsLoading', false)
    }
  },

  async fetchHostUserPendingInvoices({ commit, dispatch, rootState }) {
    commit('setIsLoading', true)

    const defaultParams = {
      size: rootState.paginate.itemsPerPage,
      page: rootState.paginate.currentPage - 1,
    }

    const params = { ...defaultParams, ...rootState.filters.filters }

    try {
      const { data } = await pendingHostInvoices(params)
      commit('setHostUserPendingInvoices', data)
    } catch ({ data }) {
        data?.errors && data?.errors?.length >= 1
          ? dispatch('showErrorMessage', errorMessages(data.errors))
          : dispatch('showErrorMessage', data.message)
    } finally {
      commit('setIsLoading', false)
    }
  },

  async createHostUserInvoice({ commit, dispatch }, invoice) {
    commit('setIsHostUserInvoiceLoading', true)

    if (invoice?.payment_ids?.length < 1) {
      commit('setIsHostUserInvoiceLoading', false)
      dispatch('showErrorMessage', Vue.i18n.translate('hausefulInvoices.messages.noInvoicePayments'))
      return
    }

    try {
      const invoiceData = {
        payments_ids: invoice.payment_ids,
        signed_object_url: {
          filename: invoice.file.name,
          filetype: invoice.file.type,
          folder_name: 'host_invoices',
        }
      }

      await createHostInvoice(invoiceData)
        .then(async ({ data }) => {
          try {
            await uploadToS3(data.signed_object_url.url, invoice.file)
            await attachHostInvoice({
              id: data.invoice_response.id,
              filename: invoice.file.name,
              external_filename: data.signed_object_url.external_filename,
            })
          } catch ({ data }) {
            dispatch('showErrorMessage', data.message)
          }
        })
        .then(() => {
          commit('closeAllModals')
          dispatch('showSuccessMessage', Vue.i18n.translate('hausefulInvoices.modals.upload.success'))
          dispatch('fetchHostUserPendingInvoices')
        })
    } catch ({ data }) {
      dispatch('showErrorMessage', data.message)
    } finally {
      commit('setIsHostUserInvoiceLoading', false)
    }
  },

  async updateHostUserInvoice({ commit, dispatch }, invoice) {
    commit('setIsHostUserInvoiceLoading', true)

    if (!invoice?.invoice_id) {
      commit('setIsHostUserInvoiceLoading', false)
      dispatch('showErrorMessage', Vue.i18n.translate('hausefulInvoices.messages.noInvoicePayments'))
      return
    }

    try {
      const invoiceData = {
        invoice_id: invoice.invoice_id,
        signed_object_url: {
          filename: invoice.file.name,
          filetype: invoice.file.type,
          folder_name: 'host_invoices',
        }
      }

      await updateFileHostInvoice(invoiceData)
        .then(async ({ data }) => {
          try {
            await uploadToS3(data.url, invoice.file)
            await attachHostInvoice({
              id: invoice.invoice_id,
              filename: invoice.file.name,
              external_filename: data.external_filename,
            })
          } catch (error) {
            dispatch('showErrorMessage', error)
          }
        })
        .then(() => {
          commit('closeAllModals')
          dispatch('showSuccessMessage', Vue.i18n.translate('hausefulInvoices.modals.upload.success'))
          dispatch('fetchHostUserInvoices')
        })
    } catch ({ data }) {
      dispatch('showErrorMessage', data.message)
    } finally {
      commit('setIsHostUserInvoiceLoading', false)
    }
  }
}

const mutations = {
  setHostUserInvoices(state, hostUserInvoices) {
    state.hostUserInvoices = hostUserInvoices
  },

  setHostUserPendingInvoices(state, hostUserPendingInvoices) {
    state.hostUserPendingInvoices = hostUserPendingInvoices
  },

  setIsHostUserInvoiceLoading(state, isHostUserInvoiceLoading) {
    state.isHostUserInvoiceLoading = isHostUserInvoiceLoading
  },
}

export default {
  state, mutations, actions, getters
}
